module.exports = __webpack_public_path__ + "static/media/i_sl.9d6eb087.pdf";